import {
  LISTAR_URAS,
  LISTAR_AUDIOS,
  LISTAR_TRONCOS,
  LISTAR_ROTAS,
  LISTAR_CENTRO_DE_CUSTOS,
  LISTAR_GRUPOS_ATENDIMENTO,
  LISTAR_FILAS,
  LISTAR_WEBHOOKS,
  LISTAR_REGEXES,
  LISTAR_CONFERENCIAS,
  LISTAR_MUSICAS_EM_ESPERA,
  LISTAR_AVALIACOES_ATENDIMENTO,
  LISTAR_TAGS,
} from './mutation-types'

export default {
  [LISTAR_TAGS]: (state, tags) => {
    state.tags = tags
  },
  [LISTAR_URAS]: (state, uras) => {
    state.uras = uras
  },
  [LISTAR_FILAS]: (state, filas) => {
    state.filas = filas
  },
  [LISTAR_REGEXES]: (state, regexes) => {
    state.regex = regexes
  },
  [LISTAR_AUDIOS]: (state, audios) => {
    state.audios = audios
  },
  [LISTAR_TRONCOS]: (state, troncos) => {
    state.troncos = troncos
  },
  [LISTAR_WEBHOOKS]: (state, webhooks) => {
    state.webhooks = webhooks
  },
  [LISTAR_ROTAS]: (state, rotas) => {
    state.rotas = rotas
  },
  [LISTAR_MUSICAS_EM_ESPERA]: (state, musicasEmEspera) => {
    state.musicasEmEspera = musicasEmEspera
  },
  [LISTAR_CENTRO_DE_CUSTOS]: (state, centroDeCustos) => {
    state.centroDeCustos = centroDeCustos
  },
  [LISTAR_GRUPOS_ATENDIMENTO]: (state, gruposAtendimento) => {
    state.gruposAtendimento = gruposAtendimento
  },
  [LISTAR_CONFERENCIAS]: (state, conferencias) => {
    state.conferencias = conferencias
  },
  [LISTAR_AVALIACOES_ATENDIMENTO]: (state, avaliacoesAtendimento) => {
    state.avaliacoesAtendimento = avaliacoesAtendimento
  },
}
